/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit DefaultView/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaSelect from 'DesignSystem/TysiaSelect/index'
import TysiaSelectContent from 'DesignSystem/TysiaSelect/TysiaSelectContent/index'
import TysiaSelectField from 'DesignSystem/TysiaSelect/TysiaSelectField/react'
import TysiaSelectLabel from 'DesignSystem/TysiaSelect/TysiaSelectLabel/index'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function DefaultView({
  children,
  viewPath = "/App/Account/Content/Settings/AdminContent/SettingsContent/TreatmentCard/Content/Content/DefaultView",
  onChange
  
}) {
let optionsValueData = fromData.useDataValue({ viewPath,
context: 'options',
})
let settingsDataDefaultViewValueData = fromData.useDataValue({ viewPath,
context: 'settings',
path: 'data.default_view',
})
let settingsDataDefaultViewChangeData = fromData.useDataChange({ viewPath,
context: 'settings',
path: 'data.default_view',
})
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
  return (<React.Fragment
>
<TysiaSelect
  viewPath={`${viewPath}/TysiaSelect`}
 allowEmptyChoice={false}
 data="options"
 from={optionsValueData}
 data="settings.data.default_view"
 onChange={settingsDataDefaultViewChangeData}
 value={settingsDataDefaultViewValueData}
 maxWidth={300}
 marginRight={dtSpaceXs}
 flexGrow={0}
>
{childProps => (
<React.Fragment>
<TysiaSelectLabel
{...childProps}
  viewPath={`${viewPath}/TysiaSelectLabel`}
 text="Default view"
/>
<TysiaSelectContent
{...childProps}
  viewPath={`${viewPath}/TysiaSelectContent`}
>
{childProps => (
<TysiaSelectField
{...childProps}
  viewPath={`${viewPath}/TysiaSelectField`}
/>
)}
</TysiaSelectContent>
</React.Fragment>
)}
</TysiaSelect>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 marginTop={dtSpaceXxs}
 text="The Compact view displays past appointments in a table. Handy for quick comparisons."
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="The Timeline view has more detail but also takes up more space."
/>
{children}
</React.Fragment>)
}